// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #0f172a;
  color: #e2e8f0;
}

.dashboard-header {
  background: linear-gradient(90deg, #1e293b 0%, #0f172a 100%);
  border-bottom: 1px solid #334155;
  padding: 20px;
}

.header-content {
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.back-button {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #334155;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #e2e8f0;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.back-button:hover {
  background-color: #475569;
  border-color: #64748b;
}

.dashboard-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #f1f5f9;
  flex: 1 1;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.logout-button:hover {
  background-color: #b91c1c;
}

.dashboard-container {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  gap: 0;
}

.servers-panel {
  width: 300px;
  background-color: #1e293b;
  border-right: 1px solid #334155;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.1s ease-out;
}

.sidebar-divider {
  width: 4px;
  background-color: #334155;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.sidebar-divider:hover {
  background-color: #475569;
}

.servers-header {
  padding: 16px;
  border-bottom: 1px solid #334155;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.servers-header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #f1f5f9;
}

.new-server-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.new-server-button:hover {
  background-color: #2563eb;
}

.loading {
  padding: 16px;
  text-align: center;
  color: #94a3b8;
}

.editor-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #0f172a;
  min-width: 100px;
}

.dashboard-nav {
  display: flex;
  gap: 0;
  background-color: #1e293b;
  border-bottom: 1px solid #334155;
  padding: 0;
  margin: 0;
  flex-shrink: 0;
}

.nav-button {
  flex: 1 1;
  min-width: 80px;
  padding: 12px 16px;
  background-color: transparent;
  color: #94a3b8;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: normal;
  word-break: break-word;
  text-align: center;
  line-height: 1.3;
}

.nav-button:hover {
  color: #cbd5e1;
  background-color: rgba(148, 163, 184, 0.05);
}

.nav-button.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
  background-color: rgba(59, 130, 246, 0.05);
}

.championships-panel {
  flex: 1 1;
  overflow-y: auto;
  background-color: #0f172a;
  padding: 20px;
}

.results-explorer-panel {
  flex: 1 1;
  overflow-y: auto;
  background-color: #0f172a;
}

/* Mobile and Tablet Responsive Styles */

@media (max-width: 1024px) {
  .dashboard-header {
    padding: 16px;
  }

  .dashboard-header h1 {
    font-size: 20px;
  }

  .header-content {
    max-width: none;
  }

  .servers-panel {
    width: 250px;
  }

  .new-server-button {
    padding: 6px 10px;
    font-size: 11px;
  }
}

/* Mobile/Touch Device Styles - JavaScript-detected */
.dashboard.is-mobile .dashboard-container {
  flex-direction: column;
  max-width: none;
}

/* Show only servers panel when in servers view */
.dashboard.is-mobile .dashboard-container.show-servers .servers-panel {
  display: flex;
  flex: 1 1;
  width: 100%;
  border-right: none;
  border-bottom: 1px solid #334155;
}

.dashboard.is-mobile .dashboard-container.show-servers .editor-panel {
  display: none;
}

/* Show only editor panel when in editor view */
.dashboard.is-mobile .dashboard-container.show-editor .servers-panel {
  display: none;
}

.dashboard.is-mobile .dashboard-container.show-editor .editor-panel {
  display: flex;
  flex: 1 1;
  width: 100%;
}

.dashboard.is-mobile .servers-panel {
  width: 100%;
  border-right: none;
}

.dashboard.is-mobile .editor-panel {
  width: 100%;
}

.dashboard.is-mobile .back-button {
  display: flex;
}

.dashboard.is-mobile .dashboard-header {
  padding: 12px 16px;
}

.dashboard.is-mobile .dashboard-header h1 {
  font-size: 18px;
  flex: 1 1;
  text-align: center;
}

.dashboard.is-mobile .header-content {
  gap: 8px;
}

.dashboard.is-mobile .new-server-button {
  padding: 4px 8px;
  font-size: 11px;
  width: 36px;
}

.dashboard.is-mobile .logout-button {
  padding: 6px 12px;
  font-size: 13px;
  width: 40px;
}

.dashboard.is-mobile .button-text {
  display: none;
}

.dashboard.is-mobile .servers-header {
  padding: 12px;
}

.dashboard.is-mobile .servers-header h2 {
  font-size: 14px;
}

@media (max-width: 900px) {
  .dashboard-container {
    flex-direction: column;
    max-width: none;
  }

  /* Show only servers panel when in servers view */
  .dashboard-container.show-servers .servers-panel {
    display: flex;
    flex: 1 1;
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #334155;
  }

  .dashboard-container.show-servers .editor-panel {
    display: none;
  }

  /* Show only editor panel when in editor view */
  .dashboard-container.show-editor .servers-panel {
    display: none;
  }

  .dashboard-container.show-editor .editor-panel {
    display: flex;
    flex: 1 1;
    width: 100%;
  }

  .servers-panel {
    width: 100%;
    border-right: none;
  }

  .editor-panel {
    width: 100%;
  }

  .back-button {
    display: flex;
  }

  .button-text {
    display: none;
  }

  .dashboard-header {
    padding: 12px 16px;
  }

  .dashboard-header h1 {
    font-size: 18px;
    flex: 1 1;
    text-align: center;
  }

  .header-content {
    gap: 8px;
  }

  .new-server-button {
    padding: 4px 8px;
    font-size: 11px;
  }

  .logout-button {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .dashboard-header {
    padding: 12px;
  }

  .dashboard-header h1 {
    font-size: 16px;
  }

  .logout-button {
    width: 40px;
    padding: 6px;
  }

  .new-server-button {
    width: 36px;
    padding: 6px;
  }

  .button-text {
    display: none;
  }

  .servers-header {
    padding: 12px;
  }

  .servers-header h2 {
    font-size: 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,yBAAyB;EACzB,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,wCAAwC;;AAExC;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,qDAAqD;AACrD;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA,iDAAiD;EACjD;IACE,aAAa;IACb,SAAO;IACP,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA,+CAA+C;EAC/C;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAO;IACP,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".dashboard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  background-color: #0f172a;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dashboard-header {\r\n  background: linear-gradient(90deg, #1e293b 0%, #0f172a 100%);\r\n  border-bottom: 1px solid #334155;\r\n  padding: 20px;\r\n}\r\n\r\n.header-content {\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.back-button {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  background-color: #334155;\r\n  border: 1px solid #475569;\r\n  border-radius: 6px;\r\n  color: #e2e8f0;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.back-button:hover {\r\n  background-color: #475569;\r\n  border-color: #64748b;\r\n}\r\n\r\n.dashboard-header h1 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #f1f5f9;\r\n  flex: 1;\r\n}\r\n\r\n.logout-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 16px;\r\n  background-color: #dc2626;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.logout-button:hover {\r\n  background-color: #b91c1c;\r\n}\r\n\r\n.dashboard-container {\r\n  display: flex;\r\n  flex: 1;\r\n  overflow: hidden;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  gap: 0;\r\n}\r\n\r\n.servers-panel {\r\n  width: 300px;\r\n  background-color: #1e293b;\r\n  border-right: 1px solid #334155;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  transition: width 0.1s ease-out;\r\n}\r\n\r\n.sidebar-divider {\r\n  width: 4px;\r\n  background-color: #334155;\r\n  cursor: col-resize;\r\n  user-select: none;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar-divider:hover {\r\n  background-color: #475569;\r\n}\r\n\r\n.servers-header {\r\n  padding: 16px;\r\n  border-bottom: 1px solid #334155;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.servers-header h2 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.new-server-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  background-color: #3b82f6;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.new-server-button:hover {\r\n  background-color: #2563eb;\r\n}\r\n\r\n.loading {\r\n  padding: 16px;\r\n  text-align: center;\r\n  color: #94a3b8;\r\n}\r\n\r\n.editor-panel {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  background-color: #0f172a;\r\n  min-width: 100px;\r\n}\r\n\r\n.dashboard-nav {\r\n  display: flex;\r\n  gap: 0;\r\n  background-color: #1e293b;\r\n  border-bottom: 1px solid #334155;\r\n  padding: 0;\r\n  margin: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.nav-button {\r\n  flex: 1;\r\n  min-width: 80px;\r\n  padding: 12px 16px;\r\n  background-color: transparent;\r\n  color: #94a3b8;\r\n  border: none;\r\n  border-bottom: 2px solid transparent;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  white-space: normal;\r\n  word-break: break-word;\r\n  text-align: center;\r\n  line-height: 1.3;\r\n}\r\n\r\n.nav-button:hover {\r\n  color: #cbd5e1;\r\n  background-color: rgba(148, 163, 184, 0.05);\r\n}\r\n\r\n.nav-button.active {\r\n  color: #3b82f6;\r\n  border-bottom-color: #3b82f6;\r\n  background-color: rgba(59, 130, 246, 0.05);\r\n}\r\n\r\n.championships-panel {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  background-color: #0f172a;\r\n  padding: 20px;\r\n}\r\n\r\n.results-explorer-panel {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  background-color: #0f172a;\r\n}\r\n\r\n/* Mobile and Tablet Responsive Styles */\r\n\r\n@media (max-width: 1024px) {\r\n  .dashboard-header {\r\n    padding: 16px;\r\n  }\r\n\r\n  .dashboard-header h1 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .header-content {\r\n    max-width: none;\r\n  }\r\n\r\n  .servers-panel {\r\n    width: 250px;\r\n  }\r\n\r\n  .new-server-button {\r\n    padding: 6px 10px;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n/* Mobile/Touch Device Styles - JavaScript-detected */\r\n.dashboard.is-mobile .dashboard-container {\r\n  flex-direction: column;\r\n  max-width: none;\r\n}\r\n\r\n/* Show only servers panel when in servers view */\r\n.dashboard.is-mobile .dashboard-container.show-servers .servers-panel {\r\n  display: flex;\r\n  flex: 1;\r\n  width: 100%;\r\n  border-right: none;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.dashboard.is-mobile .dashboard-container.show-servers .editor-panel {\r\n  display: none;\r\n}\r\n\r\n/* Show only editor panel when in editor view */\r\n.dashboard.is-mobile .dashboard-container.show-editor .servers-panel {\r\n  display: none;\r\n}\r\n\r\n.dashboard.is-mobile .dashboard-container.show-editor .editor-panel {\r\n  display: flex;\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.dashboard.is-mobile .servers-panel {\r\n  width: 100%;\r\n  border-right: none;\r\n}\r\n\r\n.dashboard.is-mobile .editor-panel {\r\n  width: 100%;\r\n}\r\n\r\n.dashboard.is-mobile .back-button {\r\n  display: flex;\r\n}\r\n\r\n.dashboard.is-mobile .dashboard-header {\r\n  padding: 12px 16px;\r\n}\r\n\r\n.dashboard.is-mobile .dashboard-header h1 {\r\n  font-size: 18px;\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.dashboard.is-mobile .header-content {\r\n  gap: 8px;\r\n}\r\n\r\n.dashboard.is-mobile .new-server-button {\r\n  padding: 4px 8px;\r\n  font-size: 11px;\r\n  width: 36px;\r\n}\r\n\r\n.dashboard.is-mobile .logout-button {\r\n  padding: 6px 12px;\r\n  font-size: 13px;\r\n  width: 40px;\r\n}\r\n\r\n.dashboard.is-mobile .button-text {\r\n  display: none;\r\n}\r\n\r\n.dashboard.is-mobile .servers-header {\r\n  padding: 12px;\r\n}\r\n\r\n.dashboard.is-mobile .servers-header h2 {\r\n  font-size: 14px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .dashboard-container {\r\n    flex-direction: column;\r\n    max-width: none;\r\n  }\r\n\r\n  /* Show only servers panel when in servers view */\r\n  .dashboard-container.show-servers .servers-panel {\r\n    display: flex;\r\n    flex: 1;\r\n    width: 100%;\r\n    border-right: none;\r\n    border-bottom: 1px solid #334155;\r\n  }\r\n\r\n  .dashboard-container.show-servers .editor-panel {\r\n    display: none;\r\n  }\r\n\r\n  /* Show only editor panel when in editor view */\r\n  .dashboard-container.show-editor .servers-panel {\r\n    display: none;\r\n  }\r\n\r\n  .dashboard-container.show-editor .editor-panel {\r\n    display: flex;\r\n    flex: 1;\r\n    width: 100%;\r\n  }\r\n\r\n  .servers-panel {\r\n    width: 100%;\r\n    border-right: none;\r\n  }\r\n\r\n  .editor-panel {\r\n    width: 100%;\r\n  }\r\n\r\n  .back-button {\r\n    display: flex;\r\n  }\r\n\r\n  .button-text {\r\n    display: none;\r\n  }\r\n\r\n  .dashboard-header {\r\n    padding: 12px 16px;\r\n  }\r\n\r\n  .dashboard-header h1 {\r\n    font-size: 18px;\r\n    flex: 1;\r\n    text-align: center;\r\n  }\r\n\r\n  .header-content {\r\n    gap: 8px;\r\n  }\r\n\r\n  .new-server-button {\r\n    padding: 4px 8px;\r\n    font-size: 11px;\r\n  }\r\n\r\n  .logout-button {\r\n    padding: 6px 12px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .dashboard-header {\r\n    padding: 12px;\r\n  }\r\n\r\n  .dashboard-header h1 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .logout-button {\r\n    width: 40px;\r\n    padding: 6px;\r\n  }\r\n\r\n  .new-server-button {\r\n    width: 36px;\r\n    padding: 6px;\r\n  }\r\n\r\n  .button-text {\r\n    display: none;\r\n  }\r\n\r\n  .servers-header {\r\n    padding: 12px;\r\n  }\r\n\r\n  .servers-header h2 {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
